import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { GlobalConstants } from '../../../common/constants/global.constant';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { countryConstants } from '../../../core/routing/constants/country.constant';
import { AuthorUser, PartnerUser } from './Interface/authors.i'
import { AuthorService } from '../../../core/routing/services/partner_content/author.service';
import { IPOSValidator } from '../../../common/validators/validators';
import { AuthorConstant } from '../../../core/routing/services/partner_content/constants/author.constant'
import { GoogleAnalyticsService } from '../../google-analytics/google-analytics.service';


@Component({
  selector: 'iposcen-authors',
  templateUrl: './authors.component.html',
  styleUrls: ['./authors.component.scss']
})
export class AuthorsComponent implements OnInit {
  @ViewChild('searchValue') animateThis: ElementRef;

  deleteTooltip = GlobalConstants.DELETE;
  AltcloseText = AuthorConstant.ALT_CLOSE;
  AltsearchText = AuthorConstant.ALT_SEARCH;
  AltdeleteText = AuthorConstant.ALT_DELETE;
  AltNewAuthorText = AuthorConstant.ALT_NEW_AUTHOR;
  searchPlaceholder = AuthorConstant.SEARCH_PLACEHOLDER;
  showInvitePopup = false;
  inviteAuthorForm: FormGroup;
  allLocations = [] as any;
  country: string;
  partner: string;
  partnerId: string;
  searchData: string;
  partnerName: string;
  userEmailAddresses = [];
  checkEdit: boolean;
  isEditable: number;
  isEmailrequired: boolean;
  checkDuplicate: boolean;
  checkDuplicateCount: number;
  checkRegistered: boolean;
  isEmailValid: boolean;
  isUserValid: boolean = false;
  invalidUserEmails: string[] = [];
  invalidUserErrorPretitle: string = '';
  invalidUserErrorPosttitle: string = '';
  inviteUserNote: string = GlobalConstants.INVITE_USER_NOTE;
  isSubmitted: boolean;
  PAT_EMAIL = IPOSValidator.EMAIL;
  userEmailsData: AuthorUser[] = [];
  userEmails: [];
  invitedEmailString: string;
  showsuccessInvitePopup: boolean;
  locationLabel: any;
  partnerLabel: any;
  enterAllEmailPlaceholderText = AuthorConstant.ENTER_ALL_EMAIL_PLACEHOLDER_TEXT;
  partnerData: any;
  partnerDetails: PartnerUser[] = [];
  isPartnerSelected: boolean;
  isLocationSelected: boolean;
  authorUserdata: AuthorUser[] = [];
  authorsCount: number;
  showFrom: number;
  showTo: number;
  totalPages: number;
  tableSize: number;
  paginationCount: number;
  email = AuthorConstant.EMAIL;
  name = AuthorConstant.NAME;
  partnerSort = AuthorConstant.PARTNER_SORT;
  location = AuthorConstant.LOCATION_SORT;
  isAscendingSort = false;
  searchQueue = {};
  sortQueue = {};
  maxSize = 5;
  filterString: string;
  page: number;
  displayAuthor = [];
  deleteAuthorId: string;
  isDeleted: boolean;
  deleteMessage: string;
  openDeleteModalPopup: boolean;
  searchClose: boolean = true;
  showSearchgBar: boolean = true;
  dataSearch: boolean = false;
  isAuthorDataEmpty: boolean;
  isSearchData: boolean;
  selectedUserRole = AuthorConstant.AUTHOR_USER_ROLE;
  updatedSort: string;
  sortType: string;
  locationSearch = GlobalConstants.ACTIVE_USRS_LOCATION;
  partnerSearch = AuthorConstant.PARTNER;
  private ngUnsubscribe = new Subject();
  objArray: any = [];
  sortBy: string;
  sortOrder: string;
    constructor(
    private formBuilder: FormBuilder,
    private authorService: AuthorService,
    private googleAnalyticsService: GoogleAnalyticsService
  ) { }

  ngOnInit(): void {
    this.page = 1;
    this.locationLabel = null;
    this.partnerLabel = null;
    this.searchData = '';
    this.updatedSort = AuthorConstant.UPDATED_TIME;
    this.sortType = AuthorConstant.DESCENDING_ORDER;
    this.sortQueue[AuthorConstant.SORT_BY] = this.updatedSort;
    this.sortQueue[AuthorConstant.SORT_TYPE] = this.sortType;
    this.getFilterSearchData();

    // this.authorService.getAllAuthor(0)
    // .subscribe(allAuthors => {
    //   this.objArray = allAuthors.user ;
    //   this.objArray.sort((a, b) => a?.name?.trim().toLowerCase().localeCompare(b?.name?.trim().toLowerCase()));
    // });   

    this.createFormGroupValuesforinvite();
    this.allLocations = countryConstants;
    this.getPartnerDetails();
    this.tableSize = 10;
    this.showFrom = ((this.page - 1) * this.tableSize) + 1;
    this.showTo = Math.min(this.page * this.tableSize);
    this.isSubmitted = false;
    this.showInvitePopup = false;
    this.isEmailValid = true;
    this.isEmailrequired = true;
    this.isLocationSelected = true;
    this.isPartnerSelected = true;
    this.showsuccessInvitePopup = false;
    this.openDeleteModalPopup = false;
    
    // For IIT2-9954 story
    // setTimeout(_ => {
    //   this.sortingTableWithAscandDesc(AuthorConstant.NAME);
    // }, 3000);
  }

  getAllAuthor(filterString?: string) {
    this.authorService.getAllAuthor(this.page, filterString)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(allAuthors => {
        this.authorUserdata = [];
        const data = allAuthors.user.map(authorsData => {
          this.authorUserdata.push(authorsData);
        }) 
        this.authorsCount = allAuthors.paginationContext.totalItems;
        this.totalPages = (allAuthors.paginationContext.totalPages);
        this.paginationCount = allAuthors.paginationContext.totalItems;
        this.showFrom = ((this.page - 1) * this.tableSize) + 1;
        this.showTo = Math.min(this.page * this.tableSize, this.paginationCount);

    // For IIT2-9954 story
        // if(this.sortOrder == 'asc'){
        //   this.objArray.sort((a, b) => a?.[`${this.sortBy}`]?.trim().toLowerCase().localeCompare(b?.[`${this.sortBy}`]?.trim().toLowerCase()));
        // }else{
        //   this.objArray.sort((b, a) => a?.[`${this.sortBy}`]?.trim().toLowerCase().localeCompare(b?.[`${this.sortBy}`]?.trim().toLowerCase()));
        // }
        // const tempArr=[];
        // for (let i = this.showFrom-1; i < this.showTo; i++) {
        //   tempArr.push(this.objArray[i]) ;        
        // } 
        // this.authorUserdata = tempArr; 
        
        this.isAuthorDataEmpty = (this.authorUserdata.length === 0) || false;
        if (this.authorUserdata.length === 0) {
          this.showFrom = 0;
          this.showTo = 0;
          this.authorsCount = 0;
          this.showSearchgBar = false;
        }
      })

  }

  createFormGroupValuesforinvite() {
    this.inviteAuthorForm = this.formBuilder.group({
      emailAddress: new FormControl('')
    });
  }

  inviteNewAuthor() {
    this.showInvitePopup = true;
    this.checkEdit = false;
    this.isSubmitted = false;
  }

  onTableDataChange(event) {
    this.page = event;
    this.getAllAuthor(this.filterString);
  }

  onCloseInvite() {
    this.showInvitePopup = false;
    this.inviteAuthorForm.reset();
    this.partnerLabel = null;
    this.locationLabel = null;
    this.isEmailValid = true;
    this.isEmailrequired = true;
    this.isLocationSelected = true;
    this.isPartnerSelected = true;
    this.checkDuplicate = false;
    this.checkDuplicateCount = 0;
    this.userEmailAddresses = [];
  }

  onLocationSelect(selectedLocation) {
    this.locationLabel = selectedLocation;
    this.country = selectedLocation;
    this.isLocationSelected = true;
  }

  onPartnerSelect(event) {
    if (event !== undefined) {
      this.partnerLabel = event.partnerId;
      this.partner = event.partnerName;
      this.partnerId = event.partnerId;
      this.isPartnerSelected = true;
    }
  }

  getPartnerDetails() {
    this.authorService.getPartnerDataByOrder(AuthorConstant.PARTNER_SORT, AuthorConstant.ASCENDING_ORDER)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(data => {
        this.partnerDetails = data.partner as PartnerUser[];
      })
  }

  searchByPartnername(partnerName) {
    this.page = 1;
    this.showSearchgBar = true;
    this.dataSearch = true;
    this.animateThis.nativeElement.blur();
    this.searchClose = true;
    this.authorService.getSearchByPartnerName(partnerName, AuthorConstant.AUTHORS_CREATED_TIME_DESC_SORT, this.page)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(data => {
        this.authorUserdata = [];
        this.isSearchData = (data.user.length === 0) || false;
        const dataAuthor = data.user.map(authorsData => {
          this.authorUserdata.push(authorsData);
        });
        this.authorsCount = data.paginationContext.totalItems;
        this.totalPages = (data.paginationContext.totalPages);
        this.paginationCount = data.paginationContext.totalItems;
        this.showFrom = ((this.page - 1) * this.tableSize) + 1;
        this.showTo = Math.min(this.page * this.tableSize, this.paginationCount);
        if (this.authorsCount === 0) {
          this.showFrom = 0;
          this.showTo = 0;
          this.authorsCount = 0;
        }
      })
  }

  clearSearch() {
    this.dataSearch = false;
    this.page = 1
    this.searchData = '';
    this.getFilterSearchData();
    this.animateThis.nativeElement.value = '';
    this.showFrom = 1;
    this.showTo = 10;
    this.page = 1;
    this.isSearchData = false;
  }

  showDeleteUserPopup(authorId, authorName) {
    this.deleteAuthorId = authorId;
    this.openDeleteModalPopup = true;
    this.isDeleted = true;
    this.deleteMessage = authorName;
  }

  deleteUser() {
    const tempuid = {
      userID: [
        this.deleteAuthorId
      ]
    };

    this.authorService.deleteAuthor(tempuid)
      .subscribe(data => {
        if (data) {
          this.isDeleted = false;
          setTimeout(_ => { this.getAllAuthor(this.filterString); }, 2000);
        }
      });
  }

  closeDeleteUserModal() {
    this.openDeleteModalPopup = false;
  }

  sort(sortKey: string) {
    switch (sortKey) {
      case (AuthorConstant.EMAIL):
        this.sortingTableWithAscandDesc(AuthorConstant.EMAIL);
        break;
      case (AuthorConstant.NAME):
        this.sortingTableWithAscandDesc(AuthorConstant.NAME);
        break;
      case (AuthorConstant.PARTNER_SORT):
        this.sortingTableWithAscandDesc(AuthorConstant.PARTNER_SORT);
        break;
      case (AuthorConstant.LOCATION_SORT):
        this.sortingTableWithAscandDesc(AuthorConstant.LOCATION_SORT);
        break;
      default: {
      }
    }
  }

  sortingTableWithAscandDesc(tempval: string) {
    let sortOrder = AuthorConstant.EMPTY_STRING;
    this.isAscendingSort = !this.isAscendingSort;
    sortOrder = this.isAscendingSort ? AuthorConstant.ASCENDING_ORDER : AuthorConstant.DESCENDING_ORDER;
    this.sortQueue[AuthorConstant.SORT_BY] = tempval;
    this.sortQueue[AuthorConstant.SORT_TYPE] = sortOrder;
    // this.sortBy=tempval;
    // this.sortOrder=sortOrder;      
    this.getFilterSearchData();
  }

  getFilterSearchData() {
    this.filterString = '';
    this.page = 1;
    if (this.sortQueue) {
      if (this.sortQueue) {
        for (const [filterKeyName, fliterData] of Object.entries(this.sortQueue)) {
          this.filterString += `&${filterKeyName}=${fliterData}`;
        }
      }
      this.getAllAuthor(this.filterString);
    }
    else {
      this.getAllAuthor();
    }
  }

  onInviteAuthor() {
    this.isLocationSelected = (this.locationLabel !== null) ? true : false;
    this.isPartnerSelected = (this.partnerLabel !== null) ? true : false;
    this.isEmailValid = true;
    this.isSubmitted = true;
    this.checkEmailRequied();
    if (this.isEmailrequired && this.isLocationSelected && this.isPartnerSelected) {
      if (this.userEmailAddresses?.length <= 0) {
        this.checkEmailvaild();
      }
      if (!this.checkDuplicate && !this.checkRegistered && this.isEmailValid) {
        const inviteContent: AuthorUser = {
          email: this.userEmailAddresses?.length <= 1 ? (
            this.inviteAuthorForm.get('emailAddress').value ?
              this.inviteAuthorForm.get('emailAddress').value : this.userEmailAddresses[0]) : this.userEmailAddresses.toString(),
          role: this.selectedUserRole,
          partnerName: this.partner ? this.partner : '',
          partnerID: this.partner ? this.partnerId : '',
          location: this.locationLabel.CountryName,
          createdByUserID: sessionStorage.getItem('userId'),
          createdByName: sessionStorage.getItem('firstname')
        };
        this.authorService.inviteAuthorUser(inviteContent)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(data => {
            if (data.responseContext.success === true) {
              this.showInvitePopup = false;
              this.invitedEmailString = this.userEmailAddresses?.length > 1 ?
                this.userEmailAddresses?.length + ' users' : (this.inviteAuthorForm.get('emailAddress').value ? this.inviteAuthorForm.get('emailAddress').value : this.userEmailAddresses[0]);
              this.showsuccessInvitePopup = true;
              this.userEmailAddresses = [];
              this.inviteAuthorForm.reset();
            }
          }, error => {
            // changes for IIT2-22817 & IIT2-22896
           if(error.responseContext.success === false){
              this.isUserValid = true;
              this.invalidUserEmails = error.responseContext.exceptionResponse.existingEmails;
              this.invalidUserErrorPretitle = GlobalConstants.INVALID_USER_ERROR_MSG_PRETITLE;
              this.invalidUserErrorPosttitle = GlobalConstants.INVALID_USER_ERROR_MSG_POSTTITLE;
        }
      });
      }
    }
  }

  onCloseSuccessPopup() {
    this.invitedEmailString = '';
    this.showsuccessInvitePopup = false;
    this.locationLabel = null;
    this.partnerLabel = null;
  }

  editEmail(event) {
    if (this.checkEdit) {
      return false;
    }
    this.checkEdit = true;
    const emailValue = this.userEmailAddresses[event];
    this.isEditable = event;
    this.userEmailAddresses.splice(event, 1);
    this.inviteAuthorForm.patchValue({ emailAddress: emailValue });
  }

  deleteEmail(indexval: number) {
    if (indexval > -1) {
      this.userEmailAddresses.splice(indexval, 1);
    }
    if (this.userEmailAddresses.includes(this.inviteAuthorForm.get('emailAddress').value
      .replace(/\n/ig, ''))) {
      this.checkDuplicate = true;
    } else {
      this.checkDuplicate = false;
    }
    // changes for IIT2-22817 & IIT2-22896
    this.invalidUserEmails = [...this.invalidUserEmails?.filter(email => this.userEmailAddresses.includes(email)) || []];
    this.isUserValid = this.invalidUserEmails?.length > 0;
  }

  onKeyUp(event) {
    if (event.key === 'Enter') {
      this.addEmail();
    } else if (event.key === ',' || event.key === ';') {
      this.checkEmailRequied();
      if (this.isEmailrequired) {
        const re = this.PAT_EMAIL;
        this.isEmailValid = re.test(this.inviteAuthorForm.get('emailAddress').value
          .slice(0, -1)
          .trim());
        if (this.isEmailValid) {
          this.userEmailAddresses.push(this.inviteAuthorForm.get('emailAddress').value
            .slice(0, -1)
            .trim());
          this.inviteAuthorForm.controls.emailAddress.reset();
        }
      }
    } else if ((event.key === 'Backspace') || (event.key === 'Delete')) {
      const emailExists = this.userEmailsData
        .find(resp => resp.email === this.inviteAuthorForm.get('emailAddress').value
          .replace(/\n/ig, ''));
      this.checkRegistered = emailExists ? true : false;
      if (emailExists) {
        this.checkDuplicateCount++;
      } else {
        this.checkRegistered = false;
        this.checkDuplicateCount--;
      }
      this.isEmailValid = true;
      this.checkDuplicate = false;
      this.checkEmailRequied();
      if (this.isEmailrequired && this.inviteAuthorForm.get('emailAddress').value) {
        this.checkEmailvaild();
      }
    }
  }

  addEmail() {
    this.isEditable = undefined;
    this.checkEdit = false;
    this.checkEmailRequied();
    if (this.isEmailrequired) {
      this.checkEmailvaild();
      this.checkDuplicateCount = 0;
      const emailExists = this.userEmailsData
        .find(resp => resp.email === this.inviteAuthorForm.get('emailAddress').value
          .replace(/\n/ig, ''));
      this.checkRegistered = emailExists ? true : false;
      if (emailExists) {
        this.checkDuplicateCount++;
      } else {
        this.checkRegistered = false;
        this.checkDuplicateCount--;
      }
      if (this.userEmailAddresses.length > 0) {
        if (this.userEmailAddresses.includes(this.inviteAuthorForm.get('emailAddress').value
          .replace(/\n/ig, ''))) {
          this.checkDuplicate = true;
        } else {
          this.checkDuplicate = false;
        }
      }
      if (this.isEmailValid && !this.checkDuplicate && !this.checkRegistered) {
        this.userEmailAddresses.push(this.inviteAuthorForm.get('emailAddress').value
          .trim()
          .replace(/\s/g, ''));
        this.inviteAuthorForm.controls.emailAddress.reset();
      }
    }
  }

  checkEmailRequied() {
    this.isEmailrequired = this.userEmailAddresses?.length || this.inviteAuthorForm.get('emailAddress').value;
  }

  checkEmailvaild() {
    const re = this.PAT_EMAIL;
    this.isEmailValid = re.test(this.inviteAuthorForm.get('emailAddress').value
      .trim()
      .replace(/[\r\n]+/gm, ''));
  }

  addBorder(wrap: HTMLElement) {
    wrap.classList.add('onfocus-border');
  }

  removeBorder(wrap: HTMLElement) {
    wrap.classList.remove('onfocus-border');
  }

  onPaste(event) {
    event.preventDefault();
    this.checkDuplicateCount = 0;
    const clipboardData = event.clipboardData;
    const pastedText = clipboardData.getData('text');
    this.userEmails = pastedText.split(/,|;/);
    this.userEmails.forEach(val => {
      if (!val) {
        return;
      }
      const re = this.PAT_EMAIL;
      this.isEmailValid = re.test(val);
      const emailExists = this.userEmailsData.find(resp => resp.email === val);
      if (emailExists) {
        this.checkRegistered = emailExists ? true : false;
        this.inviteAuthorForm.patchValue({ emailAddress: val });
        this.checkDuplicateCount++;
      } else {
        this.checkRegistered = false;
      }
      if (this.isEmailValid && this.userEmailAddresses.indexOf(val) === -1 && !this.checkRegistered) {
        this.userEmailAddresses.push(val);
      }
    });
  }

  avoidSpecialChar(event) {
    event.target.value = event.target.value.replace(/[^a-zA-Z0-9_.\-@+]/, '');
    event.target.value = event.target.value
      .replace(/\.+/g, '.')
      .replace(/_+/g, '_')
      .replace(/-+/g, '-')
      .replace(/@+/g, '@');
    event.target.value = event.target.value
      .replace(/^\./g, '')
      .replace(/^_/g, '')
      .replace(/^-/g, '')
      .replace(/^@/g, '');
    event.target.value = event.target.value
      .replace(/@\./g, '@')
      .replace(/@_/g, '@')
      .replace(/@-/g, '@');
    event.target.value = event.target.value
      .replace(IPOSValidator.AVOID_CONSECUTIVE, '$1');
  }

  countrySearchFn(term: string, item: any) {
    return item?.CountryName.toLocaleLowerCase()?.startsWith(term?.toLocaleLowerCase());
  }
}

